import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ExclusiveProperties.css';
import { EXCLUSIVE_PROPERTIES, PROPERTY_CATEGORY_ID, API_PUBLIC_HOST, SEARCH_LISTING_PREVIEW_LINK } from '@/_constant';
import ExclusivePropertyCard from './ExclusivePropertyCard';
import api from '@/apis/request';

const DUMMY_PROPERTIES = [
  {
    id: 1,
    name: 'Property Name Here',
    price: '₹ 40.50 Lac - 68 Lac',
    builder: 'Builder/group name here',
    type: 'Villa House, Residential Plot',
    location: 'RR Nagar, Bangalore, Karnataka',
    image: '/home-banner/Exclusive-Properties/design1.png'
  },
  {
    id: 2,
    name: 'Property Name Here',
    price: 'Price on Request',
    builder: 'Builder/group name here',
    type: 'Villa House, Residential Plot',
    location: 'RR Nagar, Bangalore, Karnataka',
    image: '/home-banner/Exclusive-Properties/design2.png'
  },
  {
    id: 3,
    name: 'Property Name Here',
    price: '₹ 45.00 Lac - 75 Lac',
    builder: 'Builder/group name here',
    type: 'Villa House, Residential Plot',
    location: 'RR Nagar, Bangalore, Karnataka',
    image: '/home-banner/Exclusive-Properties/design1.png'
  },
  {
    id: 4,
    name: 'Property Name Here',
    price: 'Price on Request',
    builder: 'Builder/group name here',
    type: 'Villa House, Residential Plot',
    location: 'RR Nagar, Bangalore, Karnataka',
    image: '/home-banner/Exclusive-Properties/design2.png'
  }
];

const ExclusiveProperties = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    
    const url = `${API_PUBLIC_HOST}/banner/viewListingsInBanner`;
    const payload = {
      isActive: true,
      parentCategoryId: PROPERTY_CATEGORY_ID,
      planType: "CATEGORY",
      status: ["APPROVED"],
      withGreatDealBanner: true,
      filterConditions: [],
      pageNumber: 1
    };

    api.post(url, payload)
      .then((response) => {
        setProperties(response?.data?.response?.listings || []);
      })
      .catch((error) => {
        console.error("Error fetching exclusive properties:", error);
      })
      .finally(() => {
        setLoading(false);
      });
    
  }, []);

  if (loading) {
    return null; // hide section while loading
  }

  const displayProperties = properties.length > 0 ? properties : DUMMY_PROPERTIES;
  const isDummy = properties.length === 0;

  const settings = {
    dots: false,
    infinite: displayProperties.length > 3,
    speed: 500,
    slidesToShow: Math.min(3, displayProperties.length),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: Math.min(2, displayProperties.length) }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <div className="exclusive-properties-section container py-4 mt-2">
      <div className="d-flex justify-content-between align-items-center mb-4 px-1">
        <h3 className="fw-bold mb-0 text-dark" style={{ fontSize: '1.75rem' }}>Exclusive Properties</h3>
        <button onClick={() => navigate(EXCLUSIVE_PROPERTIES, {
          state: JSON.stringify({
            category: 'property_sale_contract',
            categoryId: PROPERTY_CATEGORY_ID
          })
        })} className="btn rounded-pill px-4 py-1 d-flex align-items-center bg-white text-purple fw-bold shadow-sm top-props-view-btn">
          View all <i className="bi bi-chevron-right ms-2" style={{ fontSize: '0.8rem' }}></i>
        </button>
      </div>

      <Slider {...settings} className="exclusive-slider">
        {displayProperties.map((prop) => (
          <div key={prop.id} className="px-2 pb-3">
            <ExclusivePropertyCard
              item={prop}
              onClick={() => {
                if (isDummy) {
                  navigate(EXCLUSIVE_PROPERTIES, {
                    state: JSON.stringify({
                      category: 'property_sale_contract',
                      categoryId: PROPERTY_CATEGORY_ID
                    })
                  });
                } else {
                  navigate(SEARCH_LISTING_PREVIEW_LINK.replace(":listingId", prop.id));
                }
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ExclusiveProperties;
